import { COTTypes } from 'data/ScreensData/screenData';
import { useStore } from 'hooks/useStore';
import { targetMarketShareInstanceInterface } from 'Interfaces/FactsInterfaces/drugInterfaces';

export const useMarketStrategy = () => {
  const {
    UserStore: { userModulesRoles },
    FactsStore: {
      drugConceptsList,
      isMarketStrategyTableDataLoading,
      directMarketStrategyTableData,
      isDirectStrategyEditOpen,
      indirectMarketStrategyModalVisibility,
      toggleIndirectMarketStrategyModalVisibility,
      setIsDirectStrategyEditOpen,
      indirectMarketStrategyTableData,
      marketStrategyTableData,
      isMarketHistoryModalVisible,
      toggleMarketHistoryModalVisibility,
      marketStrategyModalVisibility,
      toggleMarketStrategyModalVisibility,
      toggleTMSViewVisibility,
      toggleTMSAddVisibility,
      setSelectedMarketStrategyIndexForEdit,
      isTmsAddModalVisible,
      isTmsViewModalVisible,
      setSelectedMarketStrategyIndexForAdd,
      setSelectedMarketStrategyIndexForView,
      isConceptsListLoading,
      tmsCalculationData,
    },
  } = useStore();

  const directStrategyHistoryClickHandler = () => {
    setIsDirectStrategyEditOpen(true);
    toggleMarketHistoryModalVisibility();
  };
  const indirectStrategyHistoryClickHandler = () => {
    setIsDirectStrategyEditOpen(false);
    toggleMarketHistoryModalVisibility();
  };

  const getRowDataByType = (
    type: string,
    isDirectTable: boolean
  ): targetMarketShareInstanceInterface | null => {
    let rowData: targetMarketShareInstanceInterface | null = null;
    if (isDirectTable) {
      directMarketStrategyTableData().forEach(row => {
        if (row.COT === type) {
          rowData = row;
        }
      });
    } else {
      indirectMarketStrategyTableData().forEach(row => {
        if (row.COT === type) {
          rowData = row;
        }
      });
    }
    return rowData;
  };

  // Gets the average of target market share
  // const getAverageOfTargetMarketShare = () => {
  //   let sum: number = 0;

  //   // calculate the sum of the direct cots
  //   COTTypes.forEach((type) => {
  //     let tempSum = 0;

  //     const directRow = getRowDataByType(type, true);
  //     tempSum += directRow
  //       ? getRoundedValueForMarketShare(directRow.TargetMarketShare)
  //       : 0;

  //     const indirectRow = getRowDataByType(type, false);
  //     tempSum += indirectRow
  //       ? getRoundedValueForMarketShare(indirectRow.TargetMarketShare)
  //       : 0;

  //     sum += tempSum;
  //   });
  //   return sum / 4;
  // };

  return {
    userModulesRoles,
    drugConceptsList,
    isMarketStrategyTableDataLoading,
    getRowDataByType,
    COTTypes,
    isDirectStrategyEditOpen,
    indirectMarketStrategyModalVisibility,
    toggleIndirectMarketStrategyModalVisibility,
    setIsDirectStrategyEditOpen,
    marketStrategyTableData,
    isMarketHistoryModalVisible,
    toggleMarketHistoryModalVisibility,
    marketStrategyModalVisibility,
    toggleMarketStrategyModalVisibility,
    setSelectedMarketStrategyIndexForEdit,
    directStrategyHistoryClickHandler,
    indirectStrategyHistoryClickHandler,
    toggleTMSViewVisibility,
    toggleTMSAddVisibility,
    isTmsAddModalVisible,
    isTmsViewModalVisible,
    setSelectedMarketStrategyIndexForAdd,
    setSelectedMarketStrategyIndexForView,
    isConceptsListLoading,
    tmsCalculationData,
  };
};
